import OpenInNewIcon from "../../../public/assets/open-in-new.svg";

export default OpenInNewIcon;
